import { api } from '../api';

const resource = '/orders';


const getAll = () => api.get(resource);
const getById = (id) => api.get(`${resource}/${id}`);
const create = (payload) => api.post(resource, payload);
const update = (id, payload) => api.put(`${resource}/${id}`, payload);
const remove = (id) => api.delete(`${resource}/${id}`);
const getAnalytics = (params = {}) => {
  const query = Object.entries(params).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&');
  return api.get(`${resource}/analytics${query ? '?' + query : ''}`);
};

export default {
  getAll,
  getById,
  create,
  update,
  remove,
  getAnalytics,
};
